import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
moment.locale('ja');

@Pipe({
  name: 'fromNow'
})
export class FromNowPipe implements PipeTransform {
  constructor() {
  }

  transform(value: any, args?: any): any {
    const today = moment().format('YMD');
    const yesterday = moment().add(-1, 'days').format('YMD');
    const ototoi = moment().add(-2, 'days').format('YMD');
    switch (moment(value).format('YMD')) {
      case (today):
        return '今日';
      case (yesterday):
        return '昨日';
      case (ototoi):
        return 'おととい';
    }
    return moment(value).fromNow();
  }

}



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/shared/pipes/from-now.pipe.ts